import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LandingNavbar from './common/LandingNavbar';
import './LandingPage.css';
import './AboutPage.css';

const FEATURES = [
  { icon: 'school', title: 'aboutPage.levelsTitle', desc: 'aboutPage.levelsDesc' },
  { icon: 'verified', title: 'aboutPage.cefrTitle', desc: 'aboutPage.cefrDesc' },
  { icon: 'psychology', title: 'aboutPage.aiTitle', desc: 'aboutPage.aiDesc' },
  { icon: 'trending_up', title: 'aboutPage.progressTitle', desc: 'aboutPage.progressDesc' }
];

const AboutPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('landing');

  return (
    <div className="about-page">
      <LandingNavbar />

      <section className="about-hero">
        <div className="about-hero-content">
          <h1>{t('aboutPage.title')}</h1>
          <p>{t('aboutPage.subtitle')}</p>
        </div>
      </section>

      <section className="about-section">
        <div className="section-container">
          <div className="about-content">
            <h2>{t('aboutPage.missionTitle')}</h2>
            <p>{t('aboutPage.mission')}</p>
          </div>
        </div>
      </section>

      <section className="about-section alt">
        <div className="section-container">
          <h2 className="section-title">{t('aboutPage.differentTitle')}</h2>
          <div className="about-features-grid">
            {FEATURES.map((feature) => (
              <div className="about-feature-card" key={feature.title}>
                <div className="about-feature-icon">
                  <span className="material-icons">{feature.icon}</span>
                </div>
                <h3>{t(feature.title)}</h3>
                <p>{t(feature.desc)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="about-cta">
        <div className="section-container">
          <h2>{t('aboutPage.ctaTitle')}</h2>
          <p>{t('aboutPage.ctaSubtitle')}</p>
          <button className="btn-primary large" onClick={() => navigate('/signup')}>
            {t('nav.startLearning')}
          </button>
        </div>
      </section>

      <footer className="landing-footer">
        <div className="footer-container">
          <div className="footer-section">
            <div className="footer-logo">
              <span className="material-icons">school</span>
              <span>Syllera</span>
            </div>
            <p className="footer-description">
              {t('footer.tagline')}
            </p>
          </div>
          <div className="footer-section">
            <h4>{t('footer.product')}</h4>
            <ul>
              <li><a href="/#features" onClick={(e) => { e.preventDefault(); navigate('/#features'); }}>{t('nav.features')}</a></li>
              <li><a href="/#pricing" onClick={(e) => { e.preventDefault(); navigate('/#pricing'); }}>{t('nav.pricing')}</a></li>
              <li><a href="/#how-it-works" onClick={(e) => { e.preventDefault(); navigate('/#how-it-works'); }}>{t('nav.howItWorks')}</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>{t('footer.company')}</h4>
            <ul>
              <li><a href="/about">{t('footer.about')}</a></li>
              <li><a href="/contact">{t('footer.contact')}</a></li>
              <li><a href="/blog">{t('footer.blog')}</a></li>
              <li><a href="/partners">{t('footer.becomeAPartner')}</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>{t('footer.support')}</h4>
            <ul>
              <li><a href="/#faq" onClick={(e) => { e.preventDefault(); navigate('/#faq'); }}>{t('footer.faq')}</a></li>
              <li><a href="/help-center">{t('footer.helpCenter')}</a></li>
              <li><a href="/contact-support">{t('footer.contactSupport')}</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>{t('footer.copyright')}</p>
          <div className="footer-links">
            <a href="/privacy-policy">{t('footer.privacyPolicy')}</a>
            <a href="/terms-of-service">{t('footer.termsOfService')}</a>
            <a href="/cookie-policy">{t('footer.cookiePolicy')}</a>
            <a href="/refund-policy">{t('footer.refundPolicy')}</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AboutPage;
